import Favorites from './favorites'

export default Favorites
